import {api} from '../../../system/api';

export default {
    deletePackage: (code, params) => api.put("packages/" + code + "/delete", {...params}, {singleRequest: true}),
};
